export default __webpack_public_path__ + "static/media/logo-footer.8a99a3db.svg";